/* AF1C product page — Shopify-wired.
 * Reads variants from window.PRODUCT (populated by Liquid).
 * Add to cart posts to /cart/add.js with the correct variant ID.
 */
(function () {
  var P = window.PRODUCT;
  if (!P) return;

  // --- Alonso hero clip: JS-managed so it works even when the user swipes to
  // the alonso product from another PDP (Liquid only server-renders it on the
  // alonso page). Single global instance we ensure/remove per swipe. ---
  var ALONSO_CLIP_URL = 'https://cdn.shopify.com/videos/c/vp/2de8c49952d5479f9c27795718efe02c/2de8c49952d5479f9c27795718efe02c.SD-480p-1.5Mbps-93192859.mp4';
  var ALONSO_CLIP_POSTER = 'https://cdn.shopify.com/s/files/1/0690/2729/9379/files/preview_images/2de8c49952d5479f9c27795718efe02c.thumbnail.0000000000.jpg?v=1788274342';

  function ensureAlonsoClip() {
    // Called when the current product becomes alonso. If a server-rendered
    // <video id="hero-clip"> exists we keep it; else we inject one into .hero-main.
    var heroMain = document.querySelector('.hero-main');
    if (!heroMain) return null;
    var clip = document.getElementById('hero-clip');
    if (!clip) {
      clip = document.createElement('video');
      clip.id = 'hero-clip';
      clip.className = 'hero-clip';
      clip.muted = true;
      clip.loop = true;
      clip.playsInline = true;
      clip.setAttribute('playsinline', '');
      clip.setAttribute('webkit-playsinline', '');
      clip.setAttribute('preload', 'auto');
      clip.setAttribute('aria-hidden', 'true');
      clip.poster = ALONSO_CLIP_POSTER;
      var src = document.createElement('source');
      src.src = ALONSO_CLIP_URL;
      src.type = 'video/mp4';
      clip.appendChild(src);
      heroMain.appendChild(clip);
    }
    try { clip.load(); } catch (e) {}
    return clip;
  }

  function removeAlonsoClip() {
    // Fully tear down when leaving the alonso product: pause, remove is-clip-active,
    // and delete the video node so it can't stay overlaid on a different shirt.
    var heroMain = document.querySelector('.hero-main');
    var clip = document.getElementById('hero-clip');
    if (heroMain) heroMain.classList.remove('is-clip-active');
    if (clip) {
      try { clip.pause(); } catch(e){}
      try { clip.removeAttribute('src'); clip.load(); } catch(e){}
      if (clip.parentNode) clip.parentNode.removeChild(clip);
    }
  }

  // Sitewide cache warm (idempotent — also runs from theme.liquid).
  (function () {
    function warm() {
      try { fetch(ALONSO_CLIP_URL, { mode: 'cors', credentials: 'omit', cache: 'force-cache' }).catch(function(){}); } catch(e){}
    }
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 });
    else setTimeout(warm, 1200);
  })();

  // If we landed on the alonso PDP directly, kick load immediately.
  if (P && P.slug === 'alonso') {
    ensureAlonsoClip();
  }

  // --- iOS pinch-zoom lockout ---
  // The viewport meta uses maximum-scale=1, user-scalable=no, but iOS Safari
  // ignores those. So we also cancel the WebKit gesture events (pinch) and the
  // double-tap zoom pattern. If the user *did* end up zoomed via Assistive
  // Touch or an Accessibility gesture, resetting document.body.style.zoom on
  // the next tap unstuck-s the layout. Passive:false is required to preventDefault.
  if ('ontouchstart' in window) {
    // Pinch: WebKit-only gesture events. Chrome mobile ignores these safely.
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (ev) {
      document.addEventListener(ev, function (e) { e.preventDefault(); }, { passive: false });
    });
    // Multi-touch guard for browsers that don't fire gesture events.
    document.addEventListener('touchmove', function (e) {
      if (e.touches && e.touches.length > 1) e.preventDefault();
    }, { passive: false });
    // Double-tap-to-zoom guard: cancel any 2nd tap within 350ms of the previous.
    var lastTouchEnd = 0;
    document.addEventListener('touchend', function (e) {
      var now = Date.now();
      if (now - lastTouchEnd <= 350) e.preventDefault();
      lastTouchEnd = now;
    }, { passive: false });
    // Belt-and-suspenders: if visualViewport reports scale > 1, reset it on next
    // interaction. This covers the accessibility-zoom stuck state.
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        if (window.visualViewport.scale > 1.01) {
          // Re-issue viewport meta to force reset.
          var vp = document.querySelector('meta[name="viewport"]');
          if (vp) {
            var orig = vp.getAttribute('content');
            vp.setAttribute('content', 'width=device-width, initial-scale=0.99, maximum-scale=1, user-scalable=no, viewport-fit=cover');
            setTimeout(function () { vp.setAttribute('content', orig); }, 50);
          }
        }
      });
    }
  }

  var FADE_MS = 320;
  var fadeToken = 0;

  var heroImg = document.getElementById('hero-img');
  var thumbFront = document.querySelector('.hero-thumb[data-side="front"]');
  var thumbBack = document.querySelector('.hero-thumb[data-side="back"]');
  var thumbFrontImg = thumbFront ? thumbFront.querySelector('img') : null;
  var thumbBackImg = thumbBack ? thumbBack.querySelector('img') : null;
  var bgAlt = document.getElementById('bg-alt');
  var sizeBtns = document.querySelectorAll('.size-btn');
  var colorSwatches = document.querySelectorAll('.color-swatch');
  var buyBtn = document.querySelector('.buy-btn');

  var currentImageSlug = P.defaultImageSlug;
  var currentSide = 'front';
  var currentTheme = P.theme;

  // --- Preload all image variants + bgs so first switch is instant. ---
  function preload(url) { var i = new Image(); i.src = url; }
  if (P.slug === 'ferrari' || P.slug === 'redbull') {
    // Ferrari/RB have two colors; preload both sides of both.
    (colorSwatches.length ? Array.from(colorSwatches) : []).forEach(function (sw) {
      var slug = sw.dataset.imageSlug;
      preload(window.AF1C_PRODUCT_IMG(slug, 'front'));
      preload(window.AF1C_PRODUCT_IMG(slug, 'back'));
    });
  } else {
    preload(window.AF1C_PRODUCT_IMG(currentImageSlug, 'back'));
  }
  Object.keys(window.AF1C_BG_URLS || {}).forEach(function (k) {
    preload(window.AF1C_BG_URLS[k]);
  });

  // --- Unified crossfade for image + bg swaps. ---
  function crossfadeTo(opts) {
    var newSlug = opts.imageSlug || currentImageSlug;
    var newSide = opts.side || currentSide;
    var newTheme = opts.theme || currentTheme;
    if (newSlug === currentImageSlug && newSide === currentSide && newTheme === currentTheme) return;

    fadeToken++;
    var myToken = fadeToken;

    // Load new bg into bg-alt (opacity 0 → 1)
    if (newTheme !== currentTheme && bgAlt) {
      bgAlt.style.backgroundImage = 'url(' + window.AF1C_BG_URLS[newTheme] + ')';
      requestAnimationFrame(function () {
        bgAlt.classList.add('is-showing');
      });
    }

    // Fade image out, swap at midpoint, fade in.
    heroImg.style.transition = 'opacity ' + FADE_MS + 'ms cubic-bezier(0.4, 0, 0.2, 1)';
    heroImg.style.opacity = '0';

    setTimeout(function () {
      if (myToken !== fadeToken) return;
      heroImg.src = window.AF1C_PRODUCT_IMG(newSlug, newSide);
      // update thumbnails too
      if (thumbFrontImg) thumbFrontImg.src = window.AF1C_PRODUCT_IMG(newSlug, 'front');
      if (thumbBackImg) thumbBackImg.src = window.AF1C_PRODUCT_IMG(newSlug, 'back');
      currentImageSlug = newSlug;
      currentSide = newSide;
      // Refresh mobile dot rail active state.
      if (typeof updateMobileChrome === 'function') { try { updateMobileChrome(); } catch(e){} }
    }, FADE_MS / 2);

    setTimeout(function () {
      if (myToken !== fadeToken) return;
      heroImg.style.opacity = '1';
    }, FADE_MS / 2 + 20);

    if (newTheme !== currentTheme) {
      setTimeout(function () {
        if (myToken !== fadeToken) return;
        document.body.dataset.theme = newTheme;
        var oldAlt = bgAlt;
        if (oldAlt) oldAlt.classList.remove('is-showing');
        currentTheme = newTheme;
      }, FADE_MS);
    }
  }

  // --- Thumbnail side toggle ---
  if (thumbFront) thumbFront.addEventListener('click', function () {
    thumbFront.classList.add('is-active');
    if (thumbBack) thumbBack.classList.remove('is-active');
    crossfadeTo({ side: 'front' });
  });
  if (thumbBack) thumbBack.addEventListener('click', function () {
    thumbBack.classList.add('is-active');
    if (thumbFront) thumbFront.classList.remove('is-active');
    crossfadeTo({ side: 'back' });
  });

  // --- Color swatches ---
  colorSwatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      colorSwatches.forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
      crossfadeTo({
        imageSlug: sw.dataset.imageSlug,
        side: 'front', // reset to front on color change
        theme: sw.dataset.theme,
      });
      // Also snap thumbnail active state back to front.
      if (thumbFront) thumbFront.classList.add('is-active');
      if (thumbBack) thumbBack.classList.remove('is-active');
    });
  });

  // --- Sizes ---
  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
    });
  });

  // --- Init from ?variant=<id> URL param ---
  // Shopify links to product pages include ?variant=<id>. Read it and preselect
  // the correct color swatch + size, and swap the hero image to match.
  (function initFromVariantParam() {
    var params = new URLSearchParams(window.location.search);
    var vid = params.get('variant');
    if (!vid) return;
    var v = P.variants.filter(function (x) {
      return String(x.id) === String(vid) || x.id === Number(vid);
    })[0];
    if (!v) return;

    // Find color from variant options and matching swatch
    var colorValue = null;
    (v.options || []).forEach(function (opt) {
      colorSwatches.forEach(function (sw) {
        if (sw.dataset.colorRaw === opt) colorValue = opt;
      });
    });
    if (colorValue) {
      var matchSw = Array.from(colorSwatches).find(function (sw) {
        return sw.dataset.colorRaw === colorValue;
      });
      if (matchSw && !matchSw.classList.contains('is-active')) {
        colorSwatches.forEach(function (s) { s.classList.remove('is-active'); });
        matchSw.classList.add('is-active');
        // Force-swap without crossfade guard (initial state).
        var newSlug = matchSw.dataset.imageSlug;
        var newTheme = matchSw.dataset.theme;
        if (newSlug && newSlug !== currentImageSlug) {
          heroImg.src = window.AF1C_PRODUCT_IMG(newSlug, 'front');
          if (thumbFrontImg) thumbFrontImg.src = window.AF1C_PRODUCT_IMG(newSlug, 'front');
          if (thumbBackImg) thumbBackImg.src = window.AF1C_PRODUCT_IMG(newSlug, 'back');
          currentImageSlug = newSlug;
        }
        if (newTheme && newTheme !== currentTheme) {
          document.body.dataset.theme = newTheme;
          currentTheme = newTheme;
        }
      }
    }

    // Find size (option1 or option2 depending on product) and select it
    var sizeValue = null;
    (v.options || []).forEach(function (opt) {
      if (['S','M','L','XL','XXL','2XL'].indexOf(opt) !== -1) sizeValue = opt;
    });
    if (sizeValue) {
      var sizeBtn = Array.from(sizeBtns).find(function (b) { return b.dataset.size === sizeValue; });
      if (sizeBtn) {
        sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
        sizeBtn.classList.add('is-selected');
      }
    }
  })();

  // --- Resolve selected → variant ID ---
  function currentVariant() {
    var sizeBtn = document.querySelector('.size-btn.is-selected');
    if (!sizeBtn) return null;
    var size = sizeBtn.dataset.size; // 'S', 'M', 'L', 'XL', '2XL'
    var color = null;
    // On mobile (max-width:900px) the mobile-color-row swatch is the source
    // of truth. The desktop .color-selector still has its own .is-active
    // swatch from initial render (defaults to first color), so a plain
    // querySelector('.color-swatch.is-active') would return the desktop
    // swatch (Red on Ferrari) even after the user tapped White on mobile.
    var activeSwatch = null;
    var mobileRow = document.querySelector('.mobile-color-row');
    if (mobileRow && window.matchMedia && window.matchMedia('(max-width: 900px)').matches) {
      activeSwatch = mobileRow.querySelector('.color-swatch.is-active');
    }
    if (!activeSwatch) {
      activeSwatch = document.querySelector('.color-swatch.is-active');
    }
    if (activeSwatch) color = activeSwatch.dataset.colorRaw; // 'Red', 'White', 'Denim', etc.

    var match = P.variants.filter(function (v) {
      var sizeMatch = (v.option2 === size) || (v.option1 === size);
      if (!sizeMatch) return false;
      if (color) {
        return v.option1 === color || v.option2 === color;
      }
      return true;
    })[0];
    return match || null;
  }

  // ==========================================================================
  // Mobile: horizontal swipe between siblings + in-place product swap.
  // Only wires up when a .product-hero exists AND we're at mobile width.
  // ==========================================================================
  var SIBS_RAW = window.AF1C_SIBLINGS || [];

  // Mobile slide list: ONE slide per product (Ferrari + RB collapse their
  // color variants into a single slide with a pill selector below the title,
  // matching desktop). Previously each color was its own swipe slide.
  var SIBS = SIBS_RAW.map(function (S) {
    return {
      handle: S.handle,
      url: S.url,
      title: S.title,
      price: S.price,
      slug: S.slug,
      theme: S.theme,
      defaultImageSlug: S.defaultImageSlug,
      hasColors: !!S.hasColors,
      colors: S.colors || [],
      variants: S.variants,
      _parentIdx: null,
      _colorIdx: null,
      _colorValue: null,
      _colorRaw: null
    };
  });

  var mainEl = document.querySelector('main');
  var heroSection = document.querySelector('.product-hero');
  var productInfo = document.querySelector('.product-info');
  var swipeHint = document.querySelector('.swipe-hint');

  function isMobile() { return window.matchMedia('(max-width: 900px)').matches; }

  // Determine current sibling index. On mobile we may have multiple slides for
  // one handle (one per color); pick the first that matches this product's handle.
  var currentIdx = -1;
  for (var i = 0; i < SIBS.length; i++) {
    if (SIBS[i].handle === P.handle) { currentIdx = i; break; }
  }

  // Update the desktop swipe-hint dots (one per raw sibling, not per mobile slide).
  function updateHintDots() {
    if (!swipeHint) return;
    var curHandle = SIBS[currentIdx] ? SIBS[currentIdx].handle : (P && P.handle);
    var rawIdx = -1;
    for (var ri = 0; ri < SIBS_RAW.length; ri++) {
      if (SIBS_RAW[ri].handle === curHandle) { rawIdx = ri; break; }
    }
    var dots = swipeHint.querySelectorAll('.swipe-hint__dot');
    dots.forEach(function (d, idx) {
      d.classList.toggle('is-active', idx === rawIdx);
    });
  }
  updateHintDots();

  // Preload sibling hero images so a swipe swap is instant.
  SIBS.forEach(function (s) {
    preload(window.AF1C_PRODUCT_IMG(s.defaultImageSlug, 'front'));
  });

  // Rewrite the DOM to reflect a new sibling. This mutates the *current* page,
  // updates window.PRODUCT + local closure variables, re-binds size buttons,
  // and pushes the correct URL to history (without full navigation).
  function swapTo(newIdx) {
    // Wrap around — swiping past the last product jumps to the first, and vice versa.
    var n = SIBS.length;
    if (!n) return;
    newIdx = ((newIdx % n) + n) % n;
    if (newIdx === currentIdx) return;
    var S = SIBS[newIdx];

    // 1) Update global PRODUCT so add-to-cart resolves the right variants.
    window.PRODUCT = {
      handle: S.handle,
      title: S.title,
      slug: S.slug,
      theme: S.theme,
      defaultImageSlug: S.defaultImageSlug,
      variants: S.variants
    };
    P = window.PRODUCT;

    // 2) Reset closure state.
    currentImageSlug = S.defaultImageSlug;
    currentSide = 'front';

    // Alonso hero clip: keep DOM in sync with the current product.
    // Non-alonso  → remove video node entirely (can't overlay another shirt).
    // Alonso      → ensure the video node is present (JS-injected if the page
    //               was server-rendered for a different product).
    if (S.slug === 'alonso') {
      ensureAlonsoClip();
    } else {
      removeAlonsoClip();
    }

    // 3) Update DOM — title, price.
    var nameEl = document.querySelector('.product-name');
    var priceEl = document.querySelector('.product-price');
    if (nameEl) nameEl.textContent = S.title.toLowerCase();
    if (priceEl) priceEl.textContent = '$' + S.price + ' usd';

    // 4) Update thumbs.
    if (thumbFrontImg) thumbFrontImg.src = window.AF1C_PRODUCT_IMG(S.defaultImageSlug, 'front');
    if (thumbBackImg) thumbBackImg.src = window.AF1C_PRODUCT_IMG(S.defaultImageSlug, 'back');
    if (thumbFront) thumbFront.classList.add('is-active');
    if (thumbBack) thumbBack.classList.remove('is-active');

    // 5) Update hero image.
    if (heroImg) {
      heroImg.src = window.AF1C_PRODUCT_IMG(S.defaultImageSlug, 'front');
      heroImg.alt = S.title.toLowerCase() + ' — front';
    }

    // 6) Update theme instantly (bg swap).
    document.body.dataset.theme = S.theme;
    document.body.dataset.slug = S.slug;
    currentTheme = S.theme;
    if (bgAlt) bgAlt.classList.remove('is-showing');

    // 7) Rebuild color selector.
    var infoEl = document.querySelector('.product-info');
    var oldColorLabel = infoEl ? infoEl.querySelector('.color-label') : null;
    var oldColorSelector = infoEl ? infoEl.querySelector('.color-selector') : null;
    if (oldColorLabel) oldColorLabel.remove();
    if (oldColorSelector) oldColorSelector.remove();

    if (S.hasColors && S.colors && S.colors.length) {
      var label = document.createElement('p');
      label.className = 'color-label';
      label.textContent = 'color';
      var wrap = document.createElement('div');
      wrap.className = 'color-selector';
      S.colors.forEach(function (c, ci) {
        var btn = document.createElement('button');
        btn.className = 'color-swatch' + (ci === 0 ? ' is-active' : '') +
                        (c.hex === '#ffffff' ? ' needs-border' : '');
        btn.dataset.color = c.value.toLowerCase();
        btn.dataset.colorRaw = c.raw;
        btn.dataset.theme = c.theme;
        btn.dataset.imageSlug = c.imageSlug;
        btn.style.setProperty('--swatch', c.hex);
        btn.setAttribute('aria-label', c.value.toLowerCase());
        wrap.appendChild(btn);
      });
      var sizeLabel = infoEl.querySelector('.size-label');
      infoEl.insertBefore(label, sizeLabel);
      infoEl.insertBefore(wrap, sizeLabel);
    }

    // 8) Rebuild size selector.
    var sizeSelector = document.querySelector('.size-selector');
    if (sizeSelector) {
      sizeSelector.innerHTML = '';
      // Distinct sizes in order S,M,L,XL,2XL/XXL from variants.
      var seen = {};
      var order = ['S','M','L','XL','2XL','XXL'];
      var sizes = [];
      S.variants.forEach(function (v) {
        var opts = v.options || [];
        opts.forEach(function (o) {
          if (order.indexOf(o) !== -1 && !seen[o]) { seen[o] = true; sizes.push(o); }
        });
      });
      sizes.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
      sizes.forEach(function (s) {
        var btn = document.createElement('button');
        btn.className = 'size-btn';
        btn.dataset.size = s;
        btn.textContent = s.toLowerCase();
        sizeSelector.appendChild(btn);
      });
    }

    // 9) Re-query button collections + rebind size + color handlers.
    sizeBtns = document.querySelectorAll('.size-btn');
    colorSwatches = document.querySelectorAll('.color-swatch');
    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
      });
    });
    colorSwatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        colorSwatches.forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        crossfadeTo({
          imageSlug: sw.dataset.imageSlug,
          side: 'front',
          theme: sw.dataset.theme,
        });
        if (thumbFront) thumbFront.classList.add('is-active');
        if (thumbBack) thumbBack.classList.remove('is-active');
      });
    });

    // 10) Update URL (no reload).
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', S.url);
    }

    // 11) Update currentIdx + dots.
    currentIdx = newIdx;
    updateHintDots();

    // 12) Reset buy button state.
    if (buyBtn) {
      buyBtn.textContent = 'add to cart';
      buyBtn.classList.remove('is-added');
      buyBtn.disabled = false;
    }

    // 13) Sync theme-color meta + peek images + mobile chrome (title/dots/row).
    syncThemeColorMeta();
    updatePeeks();
    updateMobileChrome();
  }

  // --- Inject mobile title/price badge (bottom-left) + vertical swipe hint
  //     + prev/next peek images (top+bottom, small ghost thumbnails). ---
  var mobileBadge = null, mobileBadgeName = null, mobileBadgePrice = null;
  var peekPrevImg = null, peekNextImg = null;
  var mobileTitleLine = null;
  var mobileColorRow = null;
  var mobileDotRail = null;
  var mobileSizeRow = null;
  var mobileBottomBar = null;
  (function initMobileChrome() {
    if (!mainEl) return;

    // Legacy .mobile-title-badge kept in DOM but hidden by CSS — title now
    // lives in .mobile-title-line at the top.
    mobileBadge = document.createElement('div');
    mobileBadge.className = 'mobile-title-badge';
    mobileBadgeName = document.createElement('div');
    mobileBadgeName.className = 'mtb-name';
    mobileBadgePrice = document.createElement('span');
    mobileBadgePrice.className = 'mtb-price';
    mobileBadge.appendChild(mobileBadgeName);
    mobileBadge.appendChild(mobileBadgePrice);
    mainEl.appendChild(mobileBadge);

    // Prev/Next peek images kept (hidden on mobile per design).
    if (heroSection) {
      peekPrevImg = document.createElement('img');
      peekPrevImg.className = 'peek-prev';
      peekPrevImg.alt = '';
      peekPrevImg.setAttribute('aria-hidden', 'true');
      heroSection.appendChild(peekPrevImg);

      peekNextImg = document.createElement('img');
      peekNextImg.className = 'peek-next';
      peekNextImg.alt = '';
      peekNextImg.setAttribute('aria-hidden', 'true');
      heroSection.appendChild(peekNextImg);
    }

    if (window.matchMedia('(max-width: 900px)').matches) {
      // --- Title line: `<name> - $<price>` (SKYLRK-style, above shirt) ---
      mobileTitleLine = document.createElement('div');
      mobileTitleLine.className = 'mobile-title-line';
      document.body.appendChild(mobileTitleLine);

      // --- Color pill row (only shown when product has colors) ---
      mobileColorRow = document.createElement('div');
      mobileColorRow.className = 'mobile-color-row';
      mobileColorRow.setAttribute('aria-label', 'color');
      document.body.appendChild(mobileColorRow);

      // --- Freeform dot rail (one dot per COLOR of current product) ---
      mobileDotRail = document.createElement('div');
      mobileDotRail.className = 'mobile-dot-rail';
      mobileDotRail.setAttribute('aria-hidden', 'true');
      document.body.appendChild(mobileDotRail);

      // --- Single row: size chips + add-to-cart pill ---
      mobileSizeRow = document.createElement('div');
      mobileSizeRow.className = 'mobile-size-row';
      document.body.appendChild(mobileSizeRow);

      // Bottom black bar removed — brand bg extends to safe area.

      // Move buy-btn into the size row (as inline chip).
      if (buyBtn) {
        buyBtn.classList.add('mobile-inline');
        // Note: mobileSizeRow will be populated by updateMobileChrome().
      }
    }

    updateMobileBadge();
    updatePeeks();
    updateMobileChrome();
  })();

  // Rebuild the mobile title line + dot rail + size row for the current slide.
  // Called once at init and every swipe swap.
  // MOBILE CHROME REBUILD — IRONCLAD RULES
  // 1. This function is idempotent. Call it any number of times, in any state,
  //    with any currentIdx/currentSide/currentImageSlug — output is identical.
  // 2. NEVER move DOM nodes out of .product-info. Desktop reads its own DOM;
  //    mobile builds fresh from SIBS[currentIdx]. No shared mutable source.
  // 3. Fresh <button class="color-swatch"> and <button class="size-btn"> are
  //    created here every call. Add-to-cart's document.querySelector
  //    ('.color-swatch.is-active') + ('.size-btn.is-selected') picks them up.
  // 4. Invariants assert at the end. Silent breakage = loud console error.
  function updateMobileChrome() {
    if (!window.matchMedia('(max-width: 900px)').matches) return;
    var cur = SIBS[currentIdx];
    if (!cur) return;

    // Title line: `the ferrari experience tee - $38`
    if (mobileTitleLine) {
      var t = (cur.title || P.title || '').toLowerCase();
      var pr = cur.price || (P && P.variants && P.variants[0] && String(P.variants[0].price).replace(/\.00$/, '')) || '';
      mobileTitleLine.textContent = t + (pr ? ' - $' + pr : '');
    }

    // Color row — build fresh from cur.colors. Idempotent, no DOM moves.
    if (mobileColorRow) {
      mobileColorRow.innerHTML = '';
      if (cur.hasColors && cur.colors && cur.colors.length) {
        var inner = document.createElement('div');
        inner.className = 'color-selector';
        cur.colors.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'color-swatch' + (c.hex === '#ffffff' ? ' needs-border' : '') +
                        (c.imageSlug === currentImageSlug ? ' is-active' : '');
          b.style.setProperty('--swatch', c.hex);
          b.dataset.color = (c.value || '').toLowerCase();
          b.dataset.colorRaw = c.raw;
          b.dataset.theme = c.theme;
          b.dataset.imageSlug = c.imageSlug;
          b.setAttribute('aria-label', (c.value || '').toLowerCase());
          b.addEventListener('click', function () {
            // Update active state immediately
            inner.querySelectorAll('.color-swatch').forEach(function (x) {
              x.classList.remove('is-active');
            });
            b.classList.add('is-active');
            // Crossfade image + theme. crossfadeTo will call updateMobileChrome
            // again — rebuild is safe because it reads cur.colors and marks
            // active by imageSlug match.
            crossfadeTo({
              imageSlug: c.imageSlug,
              side: 'front',
              theme: c.theme
            });
            if (thumbFront) thumbFront.classList.add('is-active');
            if (thumbBack) thumbBack.classList.remove('is-active');
          });
          inner.appendChild(b);
        });
        mobileColorRow.appendChild(inner);
        mobileColorRow.style.display = 'flex';
      } else {
        mobileColorRow.style.display = 'none';
      }
    }

    // Dot rail: two dots for front/back, plus a 3rd "clip" dot on the alonso
    // product only. Tapping a side dot flips the mockup and exits clip mode
    // if active; tapping the clip dot fades in the alonso video.
    if (mobileDotRail) {
      mobileDotRail.innerHTML = '';
      var heroMain = document.querySelector('.hero-main');
      var clipActive = heroMain && heroMain.classList.contains('is-clip-active');
      var sides = ['front','back'];
      sides.forEach(function (side) {
        var d = document.createElement('span');
        var isActive = !clipActive && (side === currentSide);
        d.className = 'mdot' + (isActive ? ' is-active' : '');
        d.setAttribute('data-side', side);
        d.addEventListener('click', function () {
          // Leaving clip mode? unfade the shirt image first.
          var hm = document.querySelector('.hero-main');
          var hc = document.getElementById('hero-clip');
          if (hm && hm.classList.contains('is-clip-active')) {
            hm.classList.remove('is-clip-active');
            if (hc) { try { hc.pause(); } catch(e){} }
            if (typeof updateMobileChrome === 'function') { try { updateMobileChrome(); } catch(e){} }
            if (side === currentSide) return;
          }
          if (side === currentSide) return;
          crossfadeTo({ side: side });
        });
        mobileDotRail.appendChild(d);
      });
      // Third dot ONLY for alonso. Uses ensureAlonsoClip() so the video is
      // created on demand even when the user swiped in from another product.
      if (cur.slug === 'alonso') {
        var dClip = document.createElement('span');
        dClip.className = 'mdot mdot--clip' + (clipActive ? ' is-active' : '');
        dClip.setAttribute('data-side', 'clip');
        dClip.setAttribute('aria-label', 'watch clip');
        dClip.addEventListener('click', function () {
          var hm = document.querySelector('.hero-main');
          if (!hm) return;
          if (hm.classList.contains('is-clip-active')) return;
          var clip = ensureAlonsoClip();
          hm.classList.add('is-clip-active');
          if (clip) { try { clip.currentTime = 0; clip.play(); } catch(e){} }
          if (mobileDotRail) {
            mobileDotRail.querySelectorAll('.mdot').forEach(function (dd) {
              dd.classList.toggle('is-active', dd.getAttribute('data-side') === 'clip');
            });
          }
        });
        mobileDotRail.appendChild(dClip);
      }
      mobileDotRail.style.display = 'flex';
    }

    // Size row — build fresh from cur.variants. Idempotent, no DOM moves.
    // Structure: two connected liquid-glass pills side-by-side
    //   .msr-sizes (wide) : holds all sizes, tap to select. Selected size gets
    //                       a filled highlight (no outline).
    //   .msr-add   (round): + icon, triggers add-to-cart. Morphs + → ✓ on
    //                       success then back to +.
    if (mobileSizeRow) {
      var prevSelected = null;
      var prevSel = mobileSizeRow.querySelector('.size-btn.is-selected');
      if (prevSel) prevSelected = prevSel.dataset.size;
      mobileSizeRow.innerHTML = '';
      // Distinct sizes S,M,L,XL,(2X)XL from this product's variants.
      var order = ['S','M','L','XL','2XL','XXL'];
      var seen = {}, sizes = [];
      (cur.variants || []).forEach(function (v) {
        (v.options || []).forEach(function (o) {
          if (order.indexOf(o) !== -1 && !seen[o]) { seen[o] = true; sizes.push(o); }
        });
      });
      sizes.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });

      // --- Left pill: sizes ---
      // Canonical liquid-glass 4-layer stack from
      // github.com/lucasromerodb/liquid-glass-effect-macos (same recipe SKYLRK uses):
      //   .liquidGlass-effect  → backdrop-filter blur + url(#glass-distortion)
      //   .liquidGlass-tint    → rgba white tint
      //   .liquidGlass-shine   → inset white specular highlight
      //   .liquidGlass-text    → the actual content, on top
      var sizesPill = document.createElement('div');
      sizesPill.className = 'liquidGlass-wrapper msr-sizes';
      var effL = document.createElement('span'); effL.className = 'liquidGlass-effect';
      var tintL = document.createElement('span'); tintL.className = 'liquidGlass-tint';
      var shineL = document.createElement('span'); shineL.className = 'liquidGlass-shine';
      sizesPill.appendChild(effL); sizesPill.appendChild(tintL); sizesPill.appendChild(shineL);
      var sizesInner = document.createElement('div');
      sizesInner.className = 'liquidGlass-text msr-sizes-inner';
      sizes.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'size-btn' + (s === prevSelected ? ' is-selected' : '');
        b.dataset.size = s;
        b.textContent = s.toLowerCase();
        b.addEventListener('click', function () {
          sizesInner.querySelectorAll('.size-btn').forEach(function (x) {
            x.classList.remove('is-selected');
          });
          b.classList.add('is-selected');
          // Arm the add pill so + fades in.
          mobileSizeRow.classList.add('is-armed');
        });
        sizesInner.appendChild(b);
      });
      // Preserve armed state if a size was already selected on last render.
      if (prevSelected) mobileSizeRow.classList.add('is-armed');
      else mobileSizeRow.classList.remove('is-armed');
      sizesPill.appendChild(sizesInner);
      mobileSizeRow.appendChild(sizesPill);

      // --- Right pill: + / ✓ (proxies to hidden desktop .buy-btn) ---
      // Same 4-layer glass stack as the sizes pill. Circular shape.
      var addPill = document.createElement('button');
      addPill.type = 'button';
      addPill.className = 'liquidGlass-wrapper msr-add';
      addPill.setAttribute('aria-label', 'add to cart');
      var effR = document.createElement('span'); effR.className = 'liquidGlass-effect';
      var tintR = document.createElement('span'); tintR.className = 'liquidGlass-tint';
      var shineR = document.createElement('span'); shineR.className = 'liquidGlass-shine';
      addPill.appendChild(effR); addPill.appendChild(tintR); addPill.appendChild(shineR);
      var iconWrap = document.createElement('span');
      iconWrap.className = 'liquidGlass-text msr-add-icon';
      // Two SVGs, cross-faded/scaled via CSS on .is-added state.
      // Two icons stacked. `.ic-check`'s stroke dash lives in CSS so the CSS
      // transition to stroke-dashoffset:0 can win (inline styles used to block
      // it — that's why the check was never appearing).
      iconWrap.innerHTML =
        '<svg class="ic-plus" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">' +
          '<line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/>' +
          '<line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/>' +
        '</svg>' +
        '<svg class="ic-check" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">' +
          '<path d="M5 12.5 L10 17.5 L19 7.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" pathLength="1"/>' +
        '</svg>';
      addPill.appendChild(iconWrap);

      addPill.addEventListener('click', function () {
        // Proxy to the real .buy-btn so all cart logic (variant lookup,
        // /cart/add.js, cart-count bump) stays in one place. We just watch
        // for the buyBtn's own state changes to morph + → ✓.
        if (!buyBtn) return;
        buyBtn.click();
      });
      mobileSizeRow.appendChild(addPill);

      // Watch buyBtn class changes to mirror is-added state onto addPill.
      // buyBtn adds .is-added when it starts "adding…" and its text becomes
      // "added ✓" on success. We flip .is-added on addPill for ~1.4s then off.
      if (buyBtn && !buyBtn.__msrObserved) {
        buyBtn.__msrObserved = true;
        var mo = new MutationObserver(function () {
          var txt = (buyBtn.textContent || '').toLowerCase();
          var active = document.querySelector('.msr-add');
          if (!active) return;
          if (txt.indexOf('added') !== -1) {
            active.classList.add('is-added');
            clearTimeout(active.__resetT);
            active.__resetT = setTimeout(function () {
              active.classList.remove('is-added');
            }, 1400);
          }
        });
        mo.observe(buyBtn, { childList: true, characterData: true, subtree: true });
      }
    }

    // --- INVARIANT ASSERTIONS — make silent breakage loud. ---
    (function assertMobileChromeInvariants() {
      var errs = [];
      if (cur.hasColors) {
        var pills = mobileColorRow ? mobileColorRow.querySelectorAll('.color-swatch').length : 0;
        if (pills !== (cur.colors || []).length) {
          errs.push('color pills=' + pills + ' expected=' + (cur.colors || []).length);
        }
        var active = mobileColorRow ? mobileColorRow.querySelector('.color-swatch.is-active') : null;
        if (!active) errs.push('no active color pill');
      }
      var chips = mobileSizeRow ? mobileSizeRow.querySelectorAll('.size-btn').length : 0;
      if (chips === 0) errs.push('size row has 0 chips');
      // Add pill lives inside mobileSizeRow now (was .buy-btn); real buy-btn
      // stays hidden in .product-info and is proxied via .msr-add click.
      var hasAdd = mobileSizeRow && mobileSizeRow.querySelector('.msr-add');
      if (!hasAdd) errs.push('size row missing add pill');
      var hasBuy = document.querySelector('.buy-btn');
      if (!hasBuy) errs.push('desktop buy-btn missing (proxy target)');
      if (errs.length) {
        console.error('[AF1C mobile chrome invariant FAIL] product=' + cur.slug +
                      ' | ' + errs.join(' | '));
      }
    })();
  }

  // Theme-color → device chrome sync. Reads the brand bg color for the current
  // theme so iOS Safari's URL bar tints to match instead of always sitting on
  // #E10600 (which caused a visible red bar on non-red themes).
  var THEME_HEX = {
    crimson: '#e10600',
    navy:    '#0e1b3a',
    charcoal:'#1c1c1e',
    olive:   '#556b2f',
    cream:   '#f2ead9',
    white:   '#ffffff'
  };
  function syncThemeColorMeta() {
    // No-op — Safari URL-bar tint follows system Light/Dark via paired
    // <meta theme-color media="(prefers-color-scheme: ...)"> in layout.
  }
  syncThemeColorMeta();

  function updateMobileBadge() {
    if (!mobileBadgeName || !mobileBadgePrice) return;
    var S = SIBS[currentIdx] || {};
    mobileBadgeName.textContent = (S.title || '').toLowerCase();
    mobileBadgePrice.textContent = '$' + (S.price || '38') + ' usd';
  }

  function updatePeeks() {
    if (!peekPrevImg || !peekNextImg || !SIBS.length) return;
    var n = SIBS.length;
    var prevS = SIBS[(currentIdx - 1 + n) % n];
    var nextS = SIBS[(currentIdx + 1) % n];
    if (prevS) peekPrevImg.src = window.AF1C_PRODUCT_IMG(prevS.defaultImageSlug, 'front');
    if (nextS) peekNextImg.src = window.AF1C_PRODUCT_IMG(nextS.defaultImageSlug, 'front');
  }

  // Dot rail removed — nav bubbles handle navigation instead.

  // Touch swipe handling on the main container. Vertical (TikTok-style) = change product.
  // Horizontal = flip mockup side (front <-> back), circular via crossfadeTo.
  (function initSwipe() {
    if (!mainEl || !heroSection || !productInfo) return;
    var startX = 0, startY = 0, currentY = 0, active = false, decided = false, isVert = false;
    var hSwiped = false;

    function onStart(e) {
      if (!isMobile()) return;
      // Multi-touch = pinch, not a swipe. Let af1c-zoom-mobile.js handle it.
      if (e.touches && e.touches.length >= 2) { active = false; return; }
      var target = e.target;
      // Don't hijack swipes on the side rail controls (color/size/buy).
      if (productInfo.contains(target)) return;
      // Don't hijack taps on the front/back thumbs pill.
      if (target.closest && target.closest('.hero-thumbs')) return;

      var t = e.touches ? e.touches[0] : e;
      startX = t.clientX; startY = t.clientY; currentY = 0;
      active = true; decided = false; isVert = false; hSwiped = false;
      heroSection.classList.add('is-swiping');
    }
    function onMove(e) {
      if (!active) return;
      // If a second finger lands mid-gesture, abort the swipe so pinch wins.
      if (e.touches && e.touches.length >= 2) {
        active = false;
        heroSection.classList.remove('is-swiping');
        return;
      }
      var t = e.touches ? e.touches[0] : e;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (!decided) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        decided = true;
        isVert = Math.abs(dy) > Math.abs(dx);
        if (!isVert) {
          // Horizontal swipe — flip front/back mockup once per gesture.
          heroSection.classList.remove('is-swiping');
          return;
        }
      }
      if (!isVert && !hSwiped) {
        var hThresh = 40;
        if (Math.abs(dx) > hThresh) {
          hSwiped = true;
          var curSlug = (SIBS[currentIdx] && SIBS[currentIdx].slug) || '';
          var isAlonso = curSlug === 'alonso';
          var hm = document.querySelector('.hero-main');
          var inClip = hm && hm.classList.contains('is-clip-active');
          var dirRight = dx > 0; // swipe right = go back one state, left = forward
          var nextState;
          if (isAlonso) {
            // 3-state cycle: front → back → clip → front
            var order = ['front', 'back', 'clip'];
            var currentState = inClip ? 'clip' : currentSide;
            var idx = order.indexOf(currentState);
            if (idx < 0) idx = 0;
            var nextIdx = dirRight ? (idx - 1 + order.length) % order.length
                                   : (idx + 1) % order.length;
            nextState = order[nextIdx];
          } else {
            nextState = (currentSide === 'front') ? 'back' : 'front';
          }

          // Helper to sync the dot-rail active class.
          var syncDots = function (activeSide) {
            var rail = document.querySelector('.mobile-dot-rail');
            if (!rail) return;
            rail.querySelectorAll('.mdot').forEach(function (d) {
              d.classList.toggle('is-active', d.getAttribute('data-side') === activeSide);
            });
          };

          if (nextState === 'clip') {
            // Enter clip mode: ensure video, fade shirt out + clip in via CSS class.
            var clipEl = ensureAlonsoClip();
            if (hm) hm.classList.add('is-clip-active');
            if (clipEl) { try { clipEl.currentTime = 0; clipEl.play(); } catch(e){} }
            syncDots('clip');
          } else {
            // Exit clip mode (if active) and swap to front or back mockup.
            if (hm && hm.classList.contains('is-clip-active')) {
              hm.classList.remove('is-clip-active');
              var hc = document.getElementById('hero-clip');
              if (hc) { try { hc.pause(); } catch(e){} }
            }
            if (typeof heroImg !== 'undefined' && heroImg && window.AF1C_PRODUCT_IMG) {
              var FADE = 180;
              heroImg.style.transition = 'opacity ' + FADE + 'ms cubic-bezier(0.4, 0, 0.2, 1)';
              heroImg.style.opacity = '0';
              setTimeout(function () {
                heroImg.src = window.AF1C_PRODUCT_IMG(currentImageSlug, nextState);
                currentSide = nextState;
                syncDots(nextState);
              }, FADE / 2);
              setTimeout(function () { heroImg.style.opacity = '1'; }, FADE / 2 + 20);
            }
          }
        }
        return;
      }
      if (!isVert) return;
      // Swipe is circular — no boundary rubber-band.
      currentY = dy;
      heroSection.style.transform = 'translateY(' + dy + 'px)';
      var h = window.innerHeight;
      heroSection.style.opacity = String(Math.max(0.35, 1 - Math.abs(dy) / (h * 0.7)));
      if (e.cancelable && isVert) e.preventDefault();
      document.dispatchEvent(new CustomEvent('af1c:swipe-drag', { detail: { dy: dy } }));
    }
    function onEnd() {
      if (!active) return;
      active = false;
      heroSection.classList.remove('is-swiping');
      var threshold = Math.min(90, window.innerHeight * 0.14);
      // Swipe UP = next product (like TikTok). Swipe DOWN = previous. Wraps at ends.
      var goPrev = currentY > threshold;
      var goNext = currentY < -threshold;
      document.dispatchEvent(new CustomEvent('af1c:swipe-end', { detail: { dir: goNext ? 'next' : (goPrev ? 'prev' : null) } }));

      if (goPrev || goNext) {
        var dir = goPrev ? 1 : -1; // positive = slide down out, negative = slide up out
        var h = window.innerHeight;
        // Start the bg crossfade IMMEDIATELY on release so the color shift
        // travels with the slide instead of snapping at midpoint.
        var targetIdx = goPrev ? currentIdx - 1 : currentIdx + 1;
        var nT = SIBS.length;
        var wrappedIdx = ((targetIdx % nT) + nT) % nT;
        var targetTheme = SIBS[wrappedIdx] && SIBS[wrappedIdx].theme;
        if (targetTheme && targetTheme !== currentTheme && bgAlt && window.AF1C_BG_URLS) {
          bgAlt.style.backgroundImage = 'url(' + window.AF1C_BG_URLS[targetTheme] + ')';
          requestAnimationFrame(function () { bgAlt.classList.add('is-showing'); });
        }
        heroSection.style.transform = 'translateY(' + (dir * h) + 'px)';
        heroSection.style.opacity = '0';
        setTimeout(function () {
          swapTo(targetIdx);
          updateMobileBadge();
          heroSection.classList.add('is-swiping');
          heroSection.style.transform = 'translateY(' + (-dir * h) + 'px)';
          heroSection.style.opacity = '0';
          void heroSection.offsetWidth;
          heroSection.classList.remove('is-swiping');
          requestAnimationFrame(function () {
            heroSection.style.transform = 'translateY(0)';
            heroSection.style.opacity = '1';
          });
        }, 340);
      } else {
        heroSection.style.transform = 'translateY(0)';
        heroSection.style.opacity = '1';
      }
      currentY = 0;
    }

    mainEl.addEventListener('touchstart', onStart, { passive: true });
    mainEl.addEventListener('touchmove', onMove, { passive: false });
    mainEl.addEventListener('touchend', onEnd);
    mainEl.addEventListener('touchcancel', onEnd);
  })();

  // Tap a swipe-hint dot to jump to that product.
  if (swipeHint) {
    swipeHint.style.pointerEvents = 'auto';
    swipeHint.querySelectorAll('.swipe-hint__dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.idx, 10);
        if (!isNaN(idx) && idx !== currentIdx) swapTo(idx);
      });
    });
  }

  // --- Add to cart ---
  if (buyBtn) buyBtn.addEventListener('click', function () {
    // On mobile the buy-btn is proxied via .msr-add; on desktop clicked directly.
    // In either case: require an explicit size selection. If none is selected,
    // nudge the size row (.msr-sizes on mobile, buy-btn label on desktop)
    // instead of silently defaulting to M.
    var isMobile = window.matchMedia('(max-width: 900px)').matches;
    if (!document.querySelector('.size-btn.is-selected')) {
      if (isMobile) {
        var sizesEl = document.querySelector('.msr-sizes');
        if (sizesEl) {
          sizesEl.classList.remove('needs-size'); // restart animation
          void sizesEl.offsetWidth;
          sizesEl.classList.add('needs-size');
          setTimeout(function () { sizesEl.classList.remove('needs-size'); }, 1400);
        }
      } else {
        buyBtn.textContent = 'select a size';
        setTimeout(function () { buyBtn.textContent = 'add to cart'; }, 1500);
      }
      return;
    }
    var v = currentVariant();
    if (!v) {
      buyBtn.textContent = 'select a size';
      setTimeout(function () { buyBtn.textContent = 'add to cart'; }, 1500);
      return;
    }
    if (!v.available) {
      buyBtn.textContent = 'sold out';
      setTimeout(function () { buyBtn.textContent = 'add to cart'; }, 1500);
      return;
    }

    var original = buyBtn.textContent;
    buyBtn.classList.add('is-added');
    buyBtn.textContent = 'adding…';
    buyBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || 'add failed');
        buyBtn.textContent = 'added ✓';
        // Update cart pill count
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            var prev = el.textContent;
            el.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
            if (String(cart.item_count) !== prev) {
              el.classList.add('is-bumping');
              setTimeout(function () { el.classList.remove('is-bumping'); }, 240);
            }
          });
          document.querySelectorAll('[data-cart-indicator]').forEach(function (el) {
            el.dataset.cartEmpty = cart.item_count === 0 ? 'true' : 'false';
          });
        });
      })
      .catch(function (err) {
        buyBtn.textContent = 'error — try again';
        console.error('cart add failed:', err);
      })
      .finally(function () {
        setTimeout(function () {
          buyBtn.classList.remove('is-added');
          buyBtn.textContent = original;
          buyBtn.disabled = false;
        }, 1400);
      });
  });
})();
